// auto-generated by {apiBaseUrl}/tools/typescriptmodels
import { Role } from "../../../data/identity/role";
import { EnvelopeDocument } from "../base/envelope-document";

export class RoleDocument extends EnvelopeDocument {
	public override Item: Role = new Role();
}